import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "country-container" }
const _hoisted_2 = { class: "premium-calculator-block__block-card block-card block-card--bg-light-purple" }
const _hoisted_3 = { class: "ekn-country-alert-container block-card__content" }
const _hoisted_4 = { class: "ekn-country-alert-text" }

import { usePremCalcStore } from "@premcalc//store/premCalcStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'importantNote',
  setup(__props) {

const store = usePremCalcStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(_unref(store).currentCountryInfo?.importantNote?.title), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_unref(store).currentCountryInfo?.importantNote?.description), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}
}

})